import { Utils } from './utils'
const inflection = require('inflection')
export const UtilsMock = new Utils({} as Window, inflection)



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/utils/utils.mock.ts